import styled from 'styled-components';

export default styled.div`
  width: 100%;
  max-width: ${props => props.isBackground ? '' : '100%'};
  margin: auto;
  position: ${props => props.isBackground ? 'absolute' : 'relative'};
  overflow: hidden;
 
  ${props => props.backgroundColor ? `background: ${props.backgroundColor};` : ' background: #000;'};
  z-index: 0;
  ${ props => props.thisStyles }
`;
